import styled from 'styled-components';
import { neutral } from '../../../style/colors';

const DocumentTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid ${neutral[200]};
  border-radius: 12px;
  padding: 24px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease;
  gap: 12px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 768px) {
    padding: 28px 24px;
  }
`;

export default DocumentTypeContainer;
